import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import PlusIcon from '../../../../UI/PlusIcon/PlusIcon';
import Translation from '../../../lang/Translation';
import useStyles from './AddNewAddress.styles';

const AddNewAddress = (props) => {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <span
      id="lbl-add-new-address"
      className={`AddNewAddress ${classes.addAddressLabel}`}
    >
      <span className={classes.icon}><PlusIcon /></span>
      
      <Translation>checkout.delivery.address.link.add.new.address.text</Translation>
      
    </span>
  );
};

AddNewAddress.propTypes = {
  isSelected: PropTypes.bool.isRequired,
};

export default AddNewAddress;
